/* wm-dmz-visualizer.js
 * DMZ Zone Visualizer — canvas animation for the Unplugged Technology section.
 * One instance per block; scoped by blockId to allow multiple blocks per page.
 */
(function () {

  /* ── Shared constants (read-only, safe to share across instances) ─────────── */
  const FILE_TYPE_COLOR = {
    jpeg:  '#E0A31A',
    png:   '#3B82F6',
    pdf:   '#7DAF00',
    json:  '#06B6D4',
    other: '#C084FC',
  };

  const TYPE_COLOR = {
    incoming_safe:    '#818cf8',
    incoming_flagged: '#f97316',
    out_1st_blocked:  '#ef4444',
    out_3rd_blocked:  '#dc2626',
    out_allowed:      '#22c55e',
  };

  const TABS = [
    { id: 'outgoing', label: 'Outgoing Data',  types: ['out_1st_blocked','out_3rd_blocked','out_allowed'] },
    { id: 'incoming', label: 'Incoming Files', types: ['incoming_safe','incoming_flagged'] },
  ];

  const APPS_IN  = ['Messages','WhatsApp','Signal','Slack','Instagram','Snapchat'];
  const FILE_TYPES = ['jpeg','jpeg','jpeg','png','png','pdf','pdf','json','other'];

  const FEED_FILTERS = {
    outgoing: [],
    incoming: [
      { id: 'jpeg',  label: 'JPEG'  },
      { id: 'png',   label: 'PNG'   },
      { id: 'pdf',   label: 'PDF'   },
      { id: 'json',  label: 'JSON'  },
      { id: 'other', label: 'Other' },
    ],
  };

  const TYPE_TO_FILTER = {
    out_allowed:     'allowed',
    out_1st_blocked: '1st',
    out_3rd_blocked: '3rd',
  };

  /* Real outgoing events from Unplugged data */
  const REAL_EVENTS = [{"app":"DuckDuckGo","status":"ALLOWED","domain":"improving.duckduckgo.com"},{"app":"DuckDuckGo","status":"ALLOWED","domain":"staticcdn.duckduckgo.com"},{"app":"Weather","status":"INTERDICTED","domain":"api.lab.amplitude.com"},{"app":"Weather","status":"ALLOWED","domain":"s.w-x.co"},{"app":"Facebook","status":"INTERDICTED","domain":"b-www.facebook.com"},{"app":"Facebook","status":"ALLOWED","domain":"scontent-phx1-1.xx.fbcdn.net"},{"app":"Facebook","status":"INTERDICTED","domain":"graph.facebook.com"},{"app":"Weather","status":"INTERDICTED","domain":"api.lab.amplitude.com"},{"app":"Outlook","status":"ALLOWED","domain":"outlook.office365.com"},{"app":"Wayfair","status":"ALLOWED","domain":"wayfair.com"},{"app":"Signal","status":"ALLOWED","domain":"storage.signal.org"},{"app":"Duolingo","status":"ALLOWED","domain":"zombie.duolingo.com"},{"app":"Facebook","status":"ALLOWED","domain":"static.xx.fbcdn.net"},{"app":"Facebook","status":"INTERDICTED","domain":"graph.facebook.com"},{"app":"Delta","status":"ALLOWED","domain":"firebase-settings.crashlytics.com"},{"app":"Delta","status":"INTERDICTED","domain":"dpm.demdex.net"},{"app":"Delta","status":"INTERDICTED","domain":"assets.adobedtm.com"},{"app":"Facebook","status":"ALLOWED","domain":"video-phx1-1.xx.fbcdn.net"},{"app":"DoorDash","status":"ALLOWED","domain":"config.mapbox.com"},{"app":"DuckDuckGo","status":"ALLOWED","domain":"duckduckgo.com"},{"app":"Slack","status":"ALLOWED","domain":"slack.com"},{"app":"Booking.com","status":"ALLOWED","domain":"mobile-apps.booking.com"},{"app":"Booking.com","status":"INTERDICTED","domain":"mobile-apps.booking.com"},{"app":"Expedia","status":"INTERDICTED","domain":"expedia.com"},{"app":"Expedia","status":"ALLOWED","domain":"expedia.no"},{"app":"Hotels.com","status":"ALLOWED","domain":"hoteles.com"},{"app":"LinkedIn","status":"INTERDICTED","domain":"linkedin.com"},{"app":"LinkedIn","status":"ALLOWED","domain":"linkedin.com"},{"app":"Momondo","status":"ALLOWED","domain":"momondo.com"},{"app":"Pinterest","status":"ALLOWED","domain":"api.pinterest.com"},{"app":"Pinterest","status":"INTERDICTED","domain":"trk.pinterest.com"},{"app":"Vrbo","status":"ALLOWED","domain":"firebase-settings.crashlytics.com"},{"app":"Vrbo","status":"INTERDICTED","domain":"firebaseremoteconfig.googleapis.com"},{"app":"Duolingo","status":"ALLOWED","domain":"android-api-cf.duolingo.com"},{"app":"DoorDash","status":"INTERDICTED","domain":"firebaseremoteconfig.googleapis.com"},{"app":"Facebook","status":"INTERDICTED","domain":"graph.facebook.com"},{"app":"X (Twitter)","status":"INTERDICTED","domain":"api.twitter.com"},{"app":"X (Twitter)","status":"ALLOWED","domain":"api.x.com"},{"app":"OneDrive","status":"ALLOWED","domain":"mobile.events.data.microsoft.com"},{"app":"Outlook","status":"ALLOWED","domain":"config.edge.skype.com"},{"app":"Google Maps","status":"ALLOWED","domain":"notifications-pa.googleapis.com"},{"app":"Lyft","status":"ALLOWED","domain":"api.lyft.bitdrift.io"},{"app":"Facebook","status":"ALLOWED","domain":"scontent-phx1-1.xx.fbcdn.net"},{"app":"Facebook","status":"INTERDICTED","domain":"graph.facebook.com"},{"app":"Weather","status":"ALLOWED","domain":"weather.com"},{"app":"Facebook","status":"ALLOWED","domain":"media1.giphy.com"},{"app":"Slack","status":"ALLOWED","domain":"slackb.com"},{"app":"Instagram","status":"INTERDICTED","domain":"graph.instagram.com"},{"app":"Instagram","status":"ALLOWED","domain":"i.instagram.com"},{"app":"YouTube","status":"ALLOWED","domain":"youtube.com"},{"app":"TikTok","status":"INTERDICTED","domain":"log.byteoversea.com"},{"app":"Spotify","status":"ALLOWED","domain":"api.spotify.com"},{"app":"Airbnb","status":"ALLOWED","domain":"api.airbnb.com"},{"app":"Uber","status":"ALLOWED","domain":"cn-geo.uber.com"},{"app":"Netflix","status":"ALLOWED","domain":"api.netflix.com"},{"app":"Snapchat","status":"INTERDICTED","domain":"snap.com"},{"app":"WhatsApp","status":"ALLOWED","domain":"whatsapp.net"},{"app":"Teams","status":"ALLOWED","domain":"teams.microsoft.com"},{"app":"Weather","status":"INTERDICTED","domain":"api.lab.amplitude.com"},{"app":"Facebook","status":"ALLOWED","domain":"scontent-phx1-1.xx.fbcdn.net"},{"app":"DuckDuckGo","status":"ALLOWED","domain":"staticcdn.duckduckgo.com"},{"app":"Facebook","status":"INTERDICTED","domain":"graph.facebook.com"},{"app":"Weather","status":"ALLOWED","domain":"s.w-x.co"},{"app":"Booking.com","status":"ALLOWED","domain":"d8c14d4960ca.edge.sdk.awswaf.com"},{"app":"Vrbo","status":"ALLOWED","domain":"api.expediapartnercentral.com"},{"app":"Facebook","status":"ALLOWED","domain":"video-phx1-1.xx.fbcdn.net"},{"app":"Delta","status":"INTERDICTED","domain":"firebaseremoteconfig.googleapis.com"},{"app":"LinkedIn","status":"INTERDICTED","domain":"linkedin.com"},{"app":"Momondo","status":"ALLOWED","domain":"momondo.de"},{"app":"Pinterest","status":"ALLOWED","domain":"api.pinterest.com"},{"app":"Facebook","status":"ALLOWED","domain":"scontent-gru1-2.xx.fbcdn.net"},{"app":"Wayfair","status":"ALLOWED","domain":"wayfair.com"},{"app":"Duolingo","status":"ALLOWED","domain":"dw58jb47l1n4t.cloudfront.net"},{"app":"Weather","status":"INTERDICTED","domain":"api.lab.amplitude.com"},{"app":"Facebook","status":"ALLOWED","domain":"static.xx.fbcdn.net"},{"app":"Facebook","status":"INTERDICTED","domain":"graph.facebook.com"},{"app":"Weather","status":"ALLOWED","domain":"upsx.weather.com"},{"app":"Facebook","status":"ALLOWED","domain":"lookaside.facebook.com"},{"app":"Hotels.com","status":"ALLOWED","domain":"expedia.com"},{"app":"Vrbo","status":"INTERDICTED","domain":"firebaseremoteconfig.googleapis.com"},{"app":"Slack","status":"ALLOWED","domain":"slack.com"},{"app":"DoorDash","status":"ALLOWED","domain":"unified-gateway.doordash.com"},{"app":"Booking.com","status":"INTERDICTED","domain":"mobile-apps.booking.com"},{"app":"Facebook","status":"ALLOWED","domain":"web.facebook.com"},{"app":"Weather","status":"INTERDICTED","domain":"api.lab.amplitude.com"},{"app":"Facebook","status":"INTERDICTED","domain":"graph.facebook.com"},{"app":"Delta","status":"ALLOWED","domain":"delta.com"},{"app":"LinkedIn","status":"ALLOWED","domain":"linkedin.com"},{"app":"DuckDuckGo","status":"ALLOWED","domain":"improving.duckduckgo.com"},{"app":"Facebook","status":"ALLOWED","domain":"scontent-phx1-1.xx.fbcdn.net"},{"app":"Weather","status":"ALLOWED","domain":"s.w-x.co"},{"app":"Facebook","status":"INTERDICTED","domain":"graph.facebook.com"},{"app":"Zappos","status":"ALLOWED","domain":"zappos.com"},{"app":"Booking.com","status":"ALLOWED","domain":"account.booking.com"},{"app":"Expedia","status":"ALLOWED","domain":"expedia.no"},{"app":"Facebook","status":"ALLOWED","domain":"video-phx1-1.xx.fbcdn.net"},{"app":"Pinterest","status":"ALLOWED","domain":"api.pinterest.com"},{"app":"DoorDash","status":"INTERDICTED","domain":"firebaseremoteconfig.googleapis.com"},{"app":"Weather","status":"INTERDICTED","domain":"api.lab.amplitude.com"}];

  /* ── Per-instance init ────────────────────────────────────────────────────── */
  function initDmzVisualizer(blockId) {
    const root = document.getElementById('wm-dmz-' + blockId);
    if (!root) return;
    const canvas = document.getElementById('wm-dmz-canvas-' + blockId);
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const DPR = window.devicePixelRatio || 1;
    const W = 340, H = 340, CX = 170, CY = 170;
    canvas.width  = W * DPR;
    canvas.height = H * DPR;
    canvas.style.width  = W + 'px';
    canvas.style.height = H + 'px';
    ctx.scale(DPR, DPR);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    const INNER_R = 62, OUTER_R = 123;

    /* Animation tuning */
    const IT_FONT_SIZE    = 9;
    const IT_WORD_FADE_IN = 10;
    const IT_SPRING       = 10;
    const IT_LINGER       = 30;
    const IT_FADE_OUT     = 0.033;
    const SQUISH_TO       = 0.50;
    const TIME_SCALE      = 1.0;
    const MOVE_SCALE      = 2.0;
    const FRAME_MS        = 1000 / 60;
    const CENTER_FADE_DUR = 20;

    /* Instance state */
    let packets = [], frame = 0;
    let spawnTimer = 0;
    let lastSpawnAngle = null;
    let borderFlash = 0;
    let verdictLabels = [];
    let activeFilter = 'outgoing';
    let activeFeedFilters = new Set(['allowed', '1st', '3rd']);
    let centerApp = null;
    let prevCenterApp = null;
    let centerFade = 1;
    let eventIndex = 0;
    let lastTime = 0;

    /* ── Helpers ──────────────────────────────────────────────────────────────── */
    function hexToRgb(hex) {
      hex = hex.replace('#', '');
      if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
      const n = parseInt(hex, 16);
      return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
    }
    function rgba(hex, a) {
      const [r, g, b] = hexToRgb(hex);
      return `rgba(${r},${g},${b},${a})`;
    }
    function lerpColor(hexA, hexB, t) {
      const [r1,g1,b1] = hexToRgb(hexA);
      const [r2,g2,b2] = hexToRgb(hexB);
      return '#' + [
        Math.round(r1 + (r2 - r1) * t),
        Math.round(g1 + (g2 - g1) * t),
        Math.round(b1 + (b2 - b1) * t),
      ].map(v => v.toString(16).padStart(2, '0')).join('');
    }

    /* ── Filter chips ────────────────────────────────────────────────────────── */
    function buildFilterChips(tabId) {
      const filtersEl = document.getElementById('wm-dmz-filters-' + blockId);
      filtersEl.innerHTML = '';
      if (tabId === 'outgoing') {
        activeFeedFilters = new Set(['allowed', '1st', '3rd']);
      } else {
        activeFeedFilters = new Set(FEED_FILTERS[tabId].map(f => f.id));
      }
      FEED_FILTERS[tabId].forEach(f => {
        const chip = document.createElement('button');
        chip.className = 'wm-dmz-chip wm-dmz-chip--on';
        chip.dataset.id = f.id;
        chip.textContent = f.label;
        const ftColor = FILE_TYPE_COLOR[f.id] || '#475CC7';
        chip.style.background = '#fff';
        chip.style.color = ftColor;
        chip.addEventListener('click', () => {
          if (activeFeedFilters.has(f.id)) {
            activeFeedFilters.delete(f.id);
            chip.classList.remove('wm-dmz-chip--on');
            chip.style.background = '';
            chip.style.color = '';
            const feedEl = document.getElementById('wm-dmz-feed-' + blockId);
            feedEl.querySelectorAll(`.wm-dmz-row[data-filetype="${f.id}"]`).forEach(r => r.remove());
          } else {
            activeFeedFilters.add(f.id);
            chip.classList.add('wm-dmz-chip--on');
            chip.style.background = '#fff';
            chip.style.color = ftColor;
          }
        });
        filtersEl.appendChild(chip);
      });
    }

    /* ── Tabs ────────────────────────────────────────────────────────────────── */
    const tabsEl = document.getElementById('wm-dmz-tabs-' + blockId);
    TABS.forEach(t => {
      const btn = document.createElement('button');
      btn.className = 'wm-dmz-tab' + (t.id === 'outgoing' ? ' wm-dmz-tab--active' : '');
      btn.textContent = t.label;
      btn.addEventListener('click', () => {
        activeFilter = t.id;
        root.querySelectorAll('.wm-dmz-tab').forEach(b => b.classList.remove('wm-dmz-tab--active'));
        btn.classList.add('wm-dmz-tab--active');
        packets = [];
        buildFilterChips(t.id);
      });
      tabsEl.appendChild(btn);
    });
    buildFilterChips('outgoing');

    /* ── Feed ────────────────────────────────────────────────────────────────── */
    function feedFilterMatch(p) {
      if (activeFilter === 'outgoing') {
        if (p.type === 'out_allowed')     return activeFeedFilters.has('allowed');
        if (p.type === 'out_1st_blocked') return activeFeedFilters.has('1st');
        if (p.type === 'out_3rd_blocked') return activeFeedFilters.has('3rd');
      }
      if (activeFilter === 'incoming') return activeFeedFilters.has(p.fileType);
      return true;
    }

    function logFeed(p) {
      if (!feedFilterMatch(p)) return;
      const labels = {
        incoming_safe:    'CLEARED',
        incoming_flagged: 'FLAGGED',
        out_1st_blocked:  'INTERDICTED',
        out_3rd_blocked:  'INTERDICTED',
        out_allowed:      'ALLOWED',
      };
      const statusColor = p.type === 'incoming_safe'   ? '#8e8e93'
                        : p.type === 'incoming_flagged' ? '#ef4444'
                        : (FILE_TYPE_COLOR[p.fileType] || TYPE_COLOR[p.type]);
      const ftColor = FILE_TYPE_COLOR[p.fileType] || '#8e8e93';
      const actionText = p.isOut
        ? p.dest
        : `<span style="color:${ftColor};font-weight:700">${p.fileType.toUpperCase()}</span> · ${p.fileSize}`;

      const feed = document.getElementById('wm-dmz-feed-' + blockId);
      const row = document.createElement('div');
      row.className = 'wm-dmz-row';
      if (p.fileType) row.dataset.filetype = p.fileType;
      row.innerHTML = `<div class="wm-dmz-row__icon"></div>
        <div class="wm-dmz-row__app">${p.app}</div>
        <div class="wm-dmz-row__action">${actionText}</div>
        <div class="wm-dmz-row__status" style="color:${statusColor}">${labels[p.type]}</div>`;
      feed.insertBefore(row, feed.firstChild);
      while (feed.children.length > 4) feed.removeChild(feed.lastChild);
    }

    /* ── File size ───────────────────────────────────────────────────────────── */
    function randomFileSize(ft) {
      const ranges = { jpeg:[80,8000], png:[150,15000], pdf:[40,50000], json:[2,800], other:[10,120000] };
      const [min, max] = ranges[ft] || [10, 5000];
      const kb = Math.floor(Math.random() * (max - min) + min);
      return kb >= 1000 ? (kb / 1000).toFixed(1) + ' MB' : kb + ' KB';
    }

    /* ── Spawn ───────────────────────────────────────────────────────────────── */
    function spawnPacket() {
      const MIN_SEP = Math.PI * 50 / 180;
      let angle, attempts = 0;
      do {
        angle = Math.random() * Math.PI * 2;
        attempts++;
      } while (lastSpawnAngle !== null && attempts < 20 &&
               Math.abs(((angle - lastSpawnAngle + Math.PI * 3) % (Math.PI * 2)) - Math.PI) < MIN_SEP);
      lastSpawnAngle = angle;

      if (activeFilter === 'outgoing') {
        let event = null, searched = 0;
        while (searched < REAL_EVENTS.length) {
          const e = REAL_EVENTS[eventIndex % REAL_EVENTS.length];
          eventIndex++;
          searched++;
          const type = e.status === 'ALLOWED' ? 'out_allowed' : 'out_1st_blocked';
          const filterKey = TYPE_TO_FILTER[type];
          if (filterKey && !activeFeedFilters.has(filterKey)) continue;
          event = { app: e.app, domain: e.domain, type };
          break;
        }
        if (!event) return;

        const app = event.app;
        if (!centerApp) {
          centerApp = app; centerFade = 1;
        } else if (app !== centerApp) {
          prevCenterApp = centerApp;
          centerApp = app; centerFade = 0;
        }

        packets.push({
          type: event.type, isOut: true, angle,
          r: INNER_R - 5, speed: 0.38 + Math.random() * 0.22,
          state: 'moving', inspectTimer: 0, opacity: 1,
          size: 4.5 + Math.random() * 2,
          app, action: '', dest: event.domain,
          fileType: null, fileSize: null, feedLogged: false,
        });

      } else {
        const weighted = [];
        ['incoming_safe','incoming_flagged'].forEach(t => {
          const w = t === 'incoming_safe' ? 40 : 1;
          for (let i = 0; i < w; i++) weighted.push(t);
        });
        const type = weighted[Math.floor(Math.random() * weighted.length)];
        const activeFileTypes = FILE_TYPES.filter(ft => activeFeedFilters.has(ft));
        if (!activeFileTypes.length) return;
        const fileType = activeFileTypes[Math.floor(Math.random() * activeFileTypes.length)];
        const fileSize = randomFileSize(fileType);
        const app = APPS_IN[Math.floor(Math.random() * APPS_IN.length)];

        packets.push({
          type, isOut: false, angle,
          r: 260, speed: 0.38 + Math.random() * 0.22,
          state: 'moving', inspectTimer: 0, opacity: 1,
          size: 4.5 + Math.random() * 2,
          app, action: '', dest: '',
          fileType, fileSize, feedLogged: false,
        });
      }
    }

    /* ── Draw ────────────────────────────────────────────────────────────────── */
    function draw() {
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = '#0e0e1a'; ctx.fillRect(0, 0, W, H);
      const vg = ctx.createRadialGradient(CX, CY, 90, CX, CY, 255);
      vg.addColorStop(0, 'rgba(0,0,20,0)');
      vg.addColorStop(1, 'rgba(0,0,20,0.35)');
      ctx.fillStyle = vg; ctx.fillRect(0, 0, W, H);

      ctx.save();
      ctx.beginPath(); ctx.arc(CX, CY, OUTER_R, 0, Math.PI * 2); ctx.clip();
      for (let r = 35; r <= OUTER_R; r += 28) {
        ctx.beginPath(); ctx.strokeStyle = 'rgba(120,110,255,0.18)'; ctx.lineWidth = 1;
        ctx.arc(CX, CY, r, 0, Math.PI * 2); ctx.stroke();
      }
      for (let a = 0; a < Math.PI * 2; a += Math.PI / 6) {
        ctx.beginPath(); ctx.strokeStyle = 'rgba(120,110,255,0.12)'; ctx.lineWidth = 1;
        ctx.moveTo(CX, CY);
        ctx.lineTo(CX + Math.cos(a) * OUTER_R, CY + Math.sin(a) * OUTER_R);
        ctx.stroke();
      }
      ctx.restore();

      const zg = ctx.createRadialGradient(CX, CY, INNER_R, CX, CY, OUTER_R);
      zg.addColorStop(0, 'rgba(100,90,255,0.10)');
      zg.addColorStop(0.5, 'rgba(100,90,255,0.22)');
      zg.addColorStop(1, 'rgba(100,90,255,0.06)');
      ctx.fillStyle = zg; ctx.beginPath(); ctx.arc(CX, CY, OUTER_R, 0, Math.PI * 2); ctx.fill();

      ctx.save();
      ctx.strokeStyle = 'rgba(120,110,255,0.70)'; ctx.lineWidth = 1.5;
      ctx.setLineDash([6, 5]); ctx.lineDashOffset = -frame * 0.25;
      ctx.beginPath(); ctx.arc(CX, CY, OUTER_R, 0, Math.PI * 2); ctx.stroke();
      ctx.restore();

      ctx.save();
      ctx.fillStyle = 'rgba(160,150,255,0.65)';
      ctx.font = '700 8px sans-serif';
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      (() => {
        const r = (INNER_R + OUTER_R) / 2;
        const text = 'DMZ', ls = 2.5;
        const ws = Array.from(text).map(c => ctx.measureText(c).width);
        const totalArc = (ws.reduce((s, w) => s + w, 0) + ls * (text.length - 1)) / r;
        const center = Math.PI / 2;
        let a = center + totalArc / 2;
        for (let j = 0; j < text.length; j++) {
          const cw = ws[j];
          const mid = a - cw / (2 * r);
          ctx.save();
          ctx.translate(CX + Math.cos(mid) * r, CY + Math.sin(mid) * r);
          ctx.rotate(mid - Math.PI / 2);
          ctx.fillText(text[j], 0, 0);
          ctx.restore();
          a -= (cw / r + ls / r);
        }
      })();
      ctx.restore();

      ctx.save();
      ctx.fillStyle = 'rgba(190,185,230,0.72)';
      ctx.strokeStyle = 'rgba(190,185,230,0.72)';
      ctx.font = '700 9px sans-serif';
      ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
      (() => {
        const tw = ctx.measureText('Internet').width;
        const gr = 4.5, gap = 4;
        const sx = CX - (gr * 2 + gap + tw) / 2;
        const ly = CY + OUTER_R + 20;
        const gx = sx + gr;
        ctx.lineWidth = 0.85;
        ctx.beginPath(); ctx.arc(gx, ly, gr, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(gx - gr, ly); ctx.lineTo(gx + gr, ly); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(gx, ly, gr * 0.48, gr, 0, 0, Math.PI * 2); ctx.stroke();
        const lo = gr * 0.52, lhw = Math.sqrt(gr * gr - lo * lo);
        ctx.beginPath(); ctx.moveTo(gx - lhw, ly - lo); ctx.lineTo(gx + lhw, ly - lo); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(gx - lhw, ly + lo); ctx.lineTo(gx + lhw, ly + lo); ctx.stroke();
        ctx.fillText('Internet', sx + gr * 2 + gap, ly);
      })();
      ctx.restore();

      const ig = ctx.createRadialGradient(CX, CY, 0, CX, CY, INNER_R);
      ig.addColorStop(0, '#1e1b38'); ig.addColorStop(1, '#16142c');
      ctx.fillStyle = ig; ctx.beginPath(); ctx.arc(CX, CY, INNER_R, 0, Math.PI * 2); ctx.fill();
      const pulse = 0.5 + 0.5 * Math.sin(frame * 0.04);
      ctx.strokeStyle = `rgba(130,120,255,${0.35 + 0.15 * pulse})`; ctx.lineWidth = 1.5;
      ctx.beginPath(); ctx.arc(CX, CY, INNER_R, 0, Math.PI * 2); ctx.stroke();

      if (activeFilter === 'outgoing') {
        ctx.save();
        ctx.translate(0, -12);
        const chipW = 42, chipH = 36, chipR = 4;
        const cx = CX - chipW / 2, cy = CY - chipH / 2;
        ctx.beginPath();
        ctx.moveTo(cx + chipR, cy); ctx.lineTo(cx + chipW - chipR, cy);
        ctx.arcTo(cx + chipW, cy, cx + chipW, cy + chipR, chipR);
        ctx.lineTo(cx + chipW, cy + chipH - chipR);
        ctx.arcTo(cx + chipW, cy + chipH, cx + chipW - chipR, cy + chipH, chipR);
        ctx.lineTo(cx + chipR, cy + chipH);
        ctx.arcTo(cx, cy + chipH, cx, cy + chipH - chipR, chipR);
        ctx.lineTo(cx, cy + chipR);
        ctx.arcTo(cx, cy, cx + chipR, cy, chipR);
        ctx.closePath();
        ctx.fillStyle = '#4a4870'; ctx.fill();
        const appPulse = 0.5 + 0.5 * Math.sin(frame * 0.022);
        ctx.shadowColor = 'rgba(160,140,255,0.3)';
        ctx.shadowBlur = 1 + 2 * appPulse;
        ctx.strokeStyle = `rgba(200,190,255,${0.08 + 0.07 * appPulse})`;
        ctx.lineWidth = 0.5; ctx.stroke(); ctx.shadowBlur = 0;

        const winW = 13, winH = 10, winGap = 3, winR = 1.5, titleH = 2.5;
        const totalW = 2 * winW + winGap, totalH = 2 * winH + winGap;
        const wx0 = CX - totalW / 2, wy0 = CY - totalH / 2;
        const winColors = ['#818cf8','#a78bfa','#34d399','#f472b6'];
        for (let row = 0; row < 2; row++) {
          for (let col = 0; col < 2; col++) {
            const idx = row * 2 + col;
            const wx = wx0 + col * (winW + winGap), wy = wy0 + row * (winH + winGap);
            const framesPerWin = 90;
            const activeWin = Math.floor(frame / framesPerWin) % 4;
            const isActive = idx === activeWin;
            const tp = frame % framesPerWin;
            const windowAlpha = isActive
              ? (tp < 8 ? 1.0 - 0.3 * (tp / 8) : tp < 68 ? 0.7 : Math.min(1, 0.7 + 0.3 * ((tp - 68) / 14)))
              : 1.0;
            const activity = 0.85;
            const col2 = winColors[idx];
            ctx.save();
            ctx.globalAlpha = windowAlpha;
            ctx.beginPath();
            ctx.moveTo(wx + winR, wy); ctx.lineTo(wx + winW - winR, wy);
            ctx.arcTo(wx + winW, wy, wx + winW, wy + winR, winR);
            ctx.lineTo(wx + winW, wy + winH - winR);
            ctx.arcTo(wx + winW, wy + winH, wx + winW - winR, wy + winH, winR);
            ctx.lineTo(wx + winR, wy + winH);
            ctx.arcTo(wx, wy + winH, wx, wy + winH - winR, winR);
            ctx.lineTo(wx, wy + winR);
            ctx.arcTo(wx, wy, wx + winR, wy, winR);
            ctx.closePath();
            ctx.fillStyle = 'rgba(255,255,255,0.10)'; ctx.fill();
            ctx.strokeStyle = `rgba(180,170,255,${0.20 + 0.30 * activity})`; ctx.lineWidth = 0.75; ctx.stroke();
            ctx.beginPath();
            ctx.moveTo(wx + winR, wy); ctx.lineTo(wx + winW - winR, wy);
            ctx.arcTo(wx + winW, wy, wx + winW, wy + winR, winR);
            ctx.lineTo(wx + winW, wy + titleH);
            ctx.lineTo(wx, wy + titleH);
            ctx.lineTo(wx, wy + winR);
            ctx.arcTo(wx, wy, wx + winR, wy, winR);
            ctx.closePath();
            const [tr, tg, tb] = hexToRgb(col2);
            ctx.fillStyle = `rgba(${tr},${tg},${tb},${0.40 + 0.50 * activity})`; ctx.fill();
            const lineY1 = wy + titleH + 2.5, lineY2 = wy + titleH + 5.0;
            let lw1, lw2;
            if (isActive && tp < 8) { const clearT = 1 - tp / 8; lw1 = (winW - 4) * clearT; lw2 = (winW - 4) * 0.6 * clearT; }
            else if (isActive && tp < 68) { const typeT = (tp - 8) / 52; lw1 = (winW - 4) * Math.min(1, typeT * 2.2); lw2 = (winW - 4) * 0.6 * Math.max(0, Math.min(1, typeT * 2.2 - 1)); }
            else { lw1 = winW - 4; lw2 = (winW - 4) * 0.6; }
            ctx.fillStyle = 'rgba(200,195,255,0.55)'; ctx.fillRect(wx + 2, lineY1, lw1, 1.2);
            ctx.fillStyle = 'rgba(200,195,255,0.40)'; ctx.fillRect(wx + 2, lineY2, lw2, 1.2);
            ctx.restore();
          }
        }
        const pinCount = 3, pinSpacing = chipH / (pinCount + 1);
        ctx.strokeStyle = 'rgba(180,170,255,0.45)'; ctx.lineWidth = 1;
        for (let i = 1; i <= pinCount; i++) {
          const py = cy + i * pinSpacing;
          ctx.beginPath(); ctx.moveTo(cx - 5, py); ctx.lineTo(cx, py); ctx.stroke();
          ctx.beginPath(); ctx.moveTo(cx + chipW, py); ctx.lineTo(cx + chipW + 5, py); ctx.stroke();
        }
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillStyle = 'rgba(190,185,230,0.85)'; ctx.font = '700 9px sans-serif';
        ctx.fillText('Application', CX, cy + chipH + 10);
        ctx.fillText('Layer', CX, cy + chipH + 21);
        ctx.restore();

      } else {
        ctx.save();
        ctx.translate(0, -12);
        const chipW = 38, chipH = 34, chipR = 4;
        const cx = CX - chipW / 2, cy = CY - chipH / 2;
        ctx.beginPath();
        ctx.moveTo(cx + chipR, cy); ctx.lineTo(cx + chipW - chipR, cy);
        ctx.arcTo(cx + chipW, cy, cx + chipW, cy + chipR, chipR);
        ctx.lineTo(cx + chipW, cy + chipH - chipR);
        ctx.arcTo(cx + chipW, cy + chipH, cx + chipW - chipR, cy + chipH, chipR);
        ctx.lineTo(cx + chipR, cy + chipH);
        ctx.arcTo(cx, cy + chipH, cx, cy + chipH - chipR, chipR);
        ctx.lineTo(cx, cy + chipR);
        ctx.arcTo(cx, cy, cx + chipR, cy, chipR);
        ctx.closePath();
        ctx.fillStyle = '#4a4870'; ctx.fill();

        const cols = 4, rows = 3, cellW = 6, cellH = 5, cellGap = 2;
        const gridTotalW = cols * cellW + (cols - 1) * cellGap;
        const gridTotalH = rows * cellH + (rows - 1) * cellGap;
        const gx = CX - gridTotalW / 2, gy = CY - gridTotalH / 2;
        for (let r = 0; r < rows; r++) {
          for (let c = 0; c < cols; c++) {
            const cellX = gx + c * (cellW + cellGap), cellY = gy + r * (cellH + cellGap);
            const active = (frame + r * 4 + c * 2) % 28 < 6;
            ctx.fillStyle = active
              ? `rgba(129,140,248,${0.9 + 0.1 * Math.sin(frame * 0.07 + r + c)})`
              : 'rgba(129,140,248,0.35)';
            ctx.fillRect(cellX, cellY, cellW, cellH);
          }
        }
        const pinCount = 4, pinSpacing = chipH / (pinCount + 1);
        ctx.strokeStyle = 'rgba(129,140,248,0.5)'; ctx.lineWidth = 1;
        for (let i = 1; i <= pinCount; i++) {
          const py = cy + i * pinSpacing;
          ctx.beginPath(); ctx.moveTo(cx - 5, py); ctx.lineTo(cx, py); ctx.stroke();
          ctx.beginPath(); ctx.moveTo(cx + chipW, py); ctx.lineTo(cx + chipW + 5, py); ctx.stroke();
        }
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillStyle = 'rgba(190,185,230,0.85)'; ctx.font = '700 9px sans-serif';
        ctx.fillText('System', CX, cy + chipH + 10);
        ctx.fillText('Memory', CX, cy + chipH + 21);
        ctx.restore();
      }

      /* Packets */
      packets.forEach(p => {
        if (!p.isOut && p.fileType && !activeFeedFilters.has(p.fileType)) return;
        const x = CX + Math.cos(p.angle) * p.r;
        const y = CY + Math.sin(p.angle) * p.r;
        const a = p.opacity;

        let col;
        if (p.state === 'done') {
          col = p.isOut ? '#ef4444' : '#f97316';
        } else if (p.state === 'cleared') {
          col = p.isOut ? '#22c55e' : '#9195A4';
        } else if (!p.isOut && p.fileType) {
          col = FILE_TYPE_COLOR[p.fileType];
        } else if (p.isOut && p.state === 'inspecting' && p.type === 'out_allowed') {
          const t = Math.max(0, Math.min((p.inspectTimer - 60) / 30, 1));
          col = lerpColor('#9195A4', '#22c55e', t);
        } else if (p.isOut && p.state === 'inspecting' && (p.type === 'out_1st_blocked' || p.type === 'out_3rd_blocked')) {
          const t = Math.max(0, Math.min((p.inspectTimer - 60) / 30, 1));
          col = lerpColor('#9195A4', '#ef4444', t);
        } else {
          col = '#9195A4';
        }

        const trailA = (p.state === 'done' && p.type === 'incoming_flagged') ? 0
          : (p.state === 'done' && p.isOut && p.ringTimer !== undefined)
          ? a * Math.max(0, 1 - p.ringTimer / 15) : a;
        const td = p.isOut ? p.angle + Math.PI : p.angle;
        const tg = ctx.createLinearGradient(x, y, x + Math.cos(td) * 22, y + Math.sin(td) * 22);
        tg.addColorStop(0, rgba(col, trailA * 0.7));
        tg.addColorStop(1, rgba(col, 0));
        ctx.beginPath(); ctx.strokeStyle = tg; ctx.lineWidth = 2;
        ctx.moveTo(x, y); ctx.lineTo(x + Math.cos(td) * 22, y + Math.sin(td) * 22); ctx.stroke();

        let scaleMult = 1;
        if (p.state === 'inspecting') {
          scaleMult = 1 - 0.50 * Math.min(p.inspectTimer / 90, 1);
        } else if (p.state === 'cleared' && p.popTimer !== undefined && p.popTimer < IT_SPRING) {
          scaleMult = 0.50 + 0.50 * (p.popTimer / IT_SPRING);
        } else if (p.state === 'done' && p.isOut && p.popTimer !== undefined && p.popTimer < IT_SPRING) {
          const t = p.popTimer / IT_SPRING;
          scaleMult = 0.50 + 0.50 * (t + 0.25 * Math.sin(t * Math.PI));
        }
        const drawSize = p.size * scaleMult;
        const burstSize = (p.state === 'done' && p.isOut && p.ringTimer !== undefined) ? p.size : drawSize;

        const glowA = (p.state === 'done' && p.type === 'incoming_flagged') ? 0
          : (p.state === 'done' && p.isOut && p.ringTimer !== undefined)
          ? a * Math.max(0, 1 - p.ringTimer / 15)
          : (!p.isOut && p.state === 'cleared') ? 0
          : a;
        const gg = ctx.createRadialGradient(x, y, 0, x, y, burstSize * 2.2);
        gg.addColorStop(0, rgba(col, glowA * 0.2));
        gg.addColorStop(1, rgba(col, 0));
        ctx.fillStyle = gg; ctx.beginPath(); ctx.arc(x, y, burstSize * 2.2, 0, Math.PI * 2); ctx.fill();

        if (!(p.state === 'done' && p.type === 'incoming_flagged')) {
          const dotA = (p.state === 'done' && p.isOut && p.ringTimer !== undefined)
            ? a * Math.max(0, 1 - p.ringTimer / 15) : a;
          ctx.beginPath(); ctx.fillStyle = rgba(col, dotA);
          ctx.arc(x, y, burstSize, 0, Math.PI * 2); ctx.fill();
        }

        if (p.state === 'inspecting') {
          const progress = Math.min(p.inspectTimer / 90, 1);
          const arcR = p.size + 4;
          let arcColor = '#888888';
          if (p.isOut && p.inspectTimer > 60) {
            const t = Math.max(0, Math.min((p.inspectTimer - 60) / 30, 1));
            if (p.type === 'out_allowed') arcColor = lerpColor('#888888', '#22c55e', t);
            else if (p.type === 'out_1st_blocked' || p.type === 'out_3rd_blocked') arcColor = lerpColor('#888888', '#ef4444', t);
          }
          ctx.beginPath(); ctx.strokeStyle = rgba(arcColor, a * 0.15); ctx.lineWidth = 2;
          ctx.arc(x, y, arcR, 0, Math.PI * 2); ctx.stroke();
          ctx.beginPath(); ctx.strokeStyle = rgba(arcColor, a * 0.85); ctx.lineWidth = 2; ctx.lineCap = 'round';
          ctx.arc(x, y, arcR, -Math.PI / 2, -Math.PI / 2 + progress * Math.PI * 2); ctx.stroke();
          ctx.lineCap = 'butt';
          const tipAngle = -Math.PI / 2 + progress * Math.PI * 2;
          ctx.beginPath(); ctx.fillStyle = rgba(arcColor, a);
          ctx.arc(x + Math.cos(tipAngle) * arcR, y + Math.sin(tipAngle) * arcR, 2.2, 0, Math.PI * 2); ctx.fill();
        }

        if (p.state === 'done' && a > 0) {
          if (p.type === 'incoming_flagged') {
            ctx.save();
            const lt = p.lingerTimer || 0;
            const POP_DUR = 12;
            const popT = Math.min(lt / POP_DUR, 1);
            const pulseFl = 0.5 + 0.5 * Math.sin(lt * 0.10 - Math.PI / 2);
            const fadeIn = Math.min(1, lt / 10);
            let dotR;
            if (lt < POP_DUR) {
              dotR = p.size * (SQUISH_TO + (1 - SQUISH_TO) * (popT + 0.25 * Math.sin(popT * Math.PI)));
            } else {
              dotR = p.size * (0.50 + Math.pow(1 - pulseFl, 2) * 0.50);
            }
            const rt = Math.min(lt / 30, 1);
            ctx.beginPath(); ctx.strokeStyle = rgba('#ef4444', (1 - rt) * 0.35);
            ctx.lineWidth = 2; ctx.arc(x, y, p.size + rt * 26, 0, Math.PI * 2); ctx.stroke();
            const gG = ctx.createRadialGradient(x, y, 0, x, y, dotR * 2.2);
            gG.addColorStop(0, rgba('#ef4444', fadeIn * 0.2)); gG.addColorStop(1, rgba('#ef4444', 0));
            ctx.fillStyle = gG; ctx.beginPath(); ctx.arc(x, y, dotR * 2.2, 0, Math.PI * 2); ctx.fill();
            const spokeFadeIn = Math.min(1, Math.max(0, lt - POP_DUR) / 10);
            const spokeOuter = p.size * 0.8 + pulseFl * 20;
            const spokeStart = spokeOuter - pulseFl * 8;
            for (let i = 0; i < 8; i++) {
              const ba = (i / 8) * Math.PI * 2;
              ctx.beginPath(); ctx.strokeStyle = rgba('#ef4444', spokeFadeIn * pulseFl * 0.85); ctx.lineWidth = 1.5;
              ctx.moveTo(x + Math.cos(ba) * spokeStart, y + Math.sin(ba) * spokeStart);
              ctx.lineTo(x + Math.cos(ba) * spokeOuter, y + Math.sin(ba) * spokeOuter); ctx.stroke();
            }
            ctx.beginPath(); ctx.fillStyle = rgba('#ef4444', 1);
            ctx.arc(x, y, dotR, 0, Math.PI * 2); ctx.fill();
            if (lt >= 22) {
              const labelFadeIn = Math.min(1, (lt - 22) / 10);
              ctx.font = `700 ${IT_FONT_SIZE}px sans-serif`;
              ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
              ctx.fillStyle = rgba('#ef4444', labelFadeIn * (0.7 + pulseFl * 0.3));
              ctx.shadowColor = rgba('#000000', labelFadeIn); ctx.shadowBlur = 8;
              ctx.fillText('FLAGGED', x, y - 18); ctx.shadowBlur = 0;
            }
            ctx.restore();
          } else {
            if (p.ringTimer !== undefined) {
              const fadeOut = Math.max(0, 1 - Math.max(0, p.ringTimer - 80) / 8);
              const glowAlpha = a * 0.25 * fadeOut;
              const rg = ctx.createRadialGradient(x, y, 0, x, y, p.size * 4);
              rg.addColorStop(0, rgba('#ef4444', glowAlpha));
              rg.addColorStop(0.5, rgba('#ef4444', glowAlpha * 0.4));
              rg.addColorStop(1, rgba('#ef4444', 0));
              ctx.fillStyle = rg; ctx.beginPath(); ctx.arc(x, y, p.size * 4, 0, Math.PI * 2); ctx.fill();
            }
            if (p.ringTimer !== undefined) {
              const t = Math.min(p.ringTimer / 30, 1);
              ctx.beginPath(); ctx.strokeStyle = rgba('#ef4444', (1 - t) * 0.82); ctx.lineWidth = 2;
              ctx.arc(x, y, p.size + t * 26, 0, Math.PI * 2); ctx.stroke();
              for (let i = 0; i < 8; i++) {
                const ba = (i / 8) * Math.PI * 2, bl = p.size * 0.8 + t * 22;
                ctx.beginPath(); ctx.strokeStyle = rgba('#ef4444', (1 - t) * 0.9); ctx.lineWidth = 1.5;
                ctx.moveTo(x + Math.cos(ba) * p.size * 0.8, y + Math.sin(ba) * p.size * 0.8);
                ctx.lineTo(x + Math.cos(ba) * bl, y + Math.sin(ba) * bl); ctx.stroke();
              }
              const fadeInR = Math.max(0, Math.min((p.ringTimer - 22) / 10, 1));
              const fadeOutR = Math.max(0, 1 - Math.max(0, p.ringTimer - 80) / 8);
              const xs = 5;
              ctx.strokeStyle = rgba('#ef4444', fadeInR * fadeOutR);
              ctx.lineWidth = 1.5;
              ctx.beginPath(); ctx.moveTo(x - xs, y - xs); ctx.lineTo(x + xs, y + xs); ctx.stroke();
              ctx.beginPath(); ctx.moveTo(x + xs, y - xs); ctx.lineTo(x - xs, y + xs); ctx.stroke();
              const wordA = Math.max(0, Math.min(p.ringTimer / IT_WORD_FADE_IN, 1)) * fadeOutR;
              ctx.save();
              ctx.font = `700 ${IT_FONT_SIZE}px sans-serif`;
              ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
              ctx.fillStyle = rgba('#ef4444', wordA);
              ctx.shadowColor = rgba('#000000', wordA); ctx.shadowBlur = 8;
              ctx.fillText('INTERDICTED', x, y - 18); ctx.shadowBlur = 0;
              ctx.restore();
            }
          }
        }

        if (p.state === 'cleared' && a > 0 && p.isOut) {
          const gg2 = ctx.createRadialGradient(x, y, 0, x, y, p.size * 3.5);
          gg2.addColorStop(0, rgba('#22c55e', a * 0.3));
          gg2.addColorStop(1, rgba('#22c55e', 0));
          ctx.fillStyle = gg2; ctx.beginPath(); ctx.arc(x, y, p.size * 3.5, 0, Math.PI * 2); ctx.fill();
        }
      });

      verdictLabels.forEach(vl => {
        ctx.save();
        ctx.globalAlpha = vl.life < 0.2 ? vl.life / 0.2 : 1.0;
        ctx.font = `700 ${vl.fontSize || 9}px sans-serif`;
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillStyle = vl.color;
        ctx.shadowColor = vl.color; ctx.shadowBlur = 6;
        ctx.fillText(vl.text, vl.x, vl.y);
        ctx.restore();
      });
    }

    /* ── Update ──────────────────────────────────────────────────────────────── */
    function update() {
      packets = packets.filter(p => p.opacity > 0);
      packets.forEach(p => {
        if (p.state === 'moving') {
          p.r += (p.isOut ? 1 : -1) * p.speed * MOVE_SCALE;
          const atBorder = p.isOut ? p.r >= OUTER_R - 14 : p.r <= INNER_R + 10;
          if (atBorder) {
            p.state = 'inspecting';
            p.r = p.isOut ? OUTER_R - 14 : INNER_R + 10;
          } else if ((p.isOut && p.r >= OUTER_R + 22) || p.r <= INNER_R - 18) {
            p.opacity = Math.max(0, p.opacity - 0.07 * TIME_SCALE);
          }

        } else if (p.state === 'inspecting') {
          p.inspectTimer += TIME_SCALE;
          if (p.inspectTimer > 90) {
            if (!p.feedLogged) { logFeed(p); p.feedLogged = true; }
            const interdicted = p.type === 'out_1st_blocked' || p.type === 'out_3rd_blocked' || p.type === 'incoming_flagged';
            if (interdicted) {
              p.state = 'done'; p.popTimer = 0;
              if (p.type !== 'incoming_flagged') p.ringTimer = 0;
            } else {
              p.state = 'cleared'; p.popTimer = 0;
            }
          }

        } else if (p.state === 'cleared') {
          if (p.popTimer !== undefined && p.popTimer < IT_SPRING) p.popTimer += TIME_SCALE;
          p.r += (p.isOut ? 1 : -1) * p.speed * MOVE_SCALE;
          if (p.isOut) {
            const x = CX + Math.cos(p.angle) * p.r, y = CY + Math.sin(p.angle) * p.r;
            if (x < -10 || x > W + 10 || y < -10 || y > H + 10) p.opacity = 0;
          } else {
            if (p.r <= INNER_R - 18) p.opacity = Math.max(0, p.opacity - 0.04 * TIME_SCALE);
          }

        } else if (p.state === 'done') {
          if (p.type === 'incoming_flagged') {
            if (!p.lingerTimer) p.lingerTimer = 0;
            p.lingerTimer += TIME_SCALE;
            if (p.lingerTimer > 420) p.opacity = Math.max(0, p.opacity - 0.011 * TIME_SCALE);
          } else {
            if (p.ringTimer === undefined) p.ringTimer = 0;
            p.ringTimer += TIME_SCALE;
            if (p.popTimer !== undefined && p.popTimer < IT_SPRING) {
              p.popTimer += TIME_SCALE;
            } else {
              if (!p.interdictLinger) p.interdictLinger = 0;
              if (p.interdictLinger < IT_LINGER) {
                p.interdictLinger += TIME_SCALE;
              } else {
                p.opacity = Math.max(0, p.opacity - IT_FADE_OUT * TIME_SCALE);
              }
            }
          }
        }
      });

      verdictLabels.forEach(vl => { vl.life = Math.max(0, vl.life - (vl.fadeRate || 0.013) * TIME_SCALE); });
      verdictLabels = verdictLabels.filter(vl => vl.life > 0);
      if (borderFlash > 0) borderFlash--;
    }

    /* ── Loop ────────────────────────────────────────────────────────────────── */
    function loop(timestamp) {
      requestAnimationFrame(loop);
      if (timestamp - lastTime < FRAME_MS) return;
      lastTime = timestamp;
      frame++;
      spawnTimer++;
      if (spawnTimer >= 60) { spawnPacket(); spawnTimer = 0; }
      if (centerFade < 1) {
        centerFade = Math.min(1, centerFade + TIME_SCALE / CENTER_FADE_DUR);
        if (centerFade >= 1) { prevCenterApp = null; }
      }
      update();
      draw();
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      draw();
    } else {
      requestAnimationFrame(loop);
    }
  }

  /* ── Bootstrap ───────────────────────────────────────────────────────────── */
  function initById(id) {
    const el = document.getElementById('wm-dmz-' + id);
    if (el && !el.dataset.initialized) {
      el.dataset.initialized = '1';
      initDmzVisualizer(id);
    }
  }

  /* Process IDs queued by inline block scripts before this deferred file ran */
  (window.__dmzQueue || []).forEach(initById);

  /* Replace array with live handler — any future push() (theme editor) runs immediately */
  window.__dmzQueue = { push: initById };

  /* Theme editor: re-init when a block is added/reloaded */
  document.addEventListener('shopify:block:load', function (e) {
    const blockId = e.detail && e.detail.blockId;
    if (blockId) initById(blockId);
  });

})();
